"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var api_1 = require("../api");
var button_1 = __importDefault(require("./button"));
var sound_admin_option_1 = __importDefault(require("./sound_admin_option"));
var sound_1 = require("../sound");
var utils_1 = require("../utils");
var react_easy_sort_1 = __importStar(require("react-easy-sort"));
function SoundAdmin(_a) {
    var _this = this;
    var guildId = _a.guildId, height = _a.height, soundList = _a.soundList;
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var isSoundListLoading = soundList.isLoading, categories = soundList.categories, sounds = soundList.sounds;
    var _c = (0, react_1.useState)(null), activeCategory = _c[0], setActiveCategory = _c[1];
    (0, react_1.useEffect)(function () {
        if (!activeCategory) {
            setActiveCategory(categories.get()[0]);
        }
    }, [categories]);
    var setIsLoadingTimeout = function (value) {
        return setTimeout(function () { return setIsLoading(value); }, 250);
    };
    var addCategory = function () { return __awaiter(_this, void 0, void 0, function () {
        var name, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    name = (_c = prompt('Enter category name:')) === null || _c === void 0 ? void 0 : _c.trim();
                    if (!name)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _b = (_a = categories).update;
                    return [4 /*yield*/, api_1.api.saveCategory({
                            name: name,
                            guildId: guildId,
                            sort: (categories.length() + 1) * 1000,
                        })];
                case 1:
                    _b.apply(_a, [_d.sent()]);
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteCategory = function (category) { return __awaiter(_this, void 0, void 0, function () {
        var catSounds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    catSounds = sounds
                        .get()
                        .filter(function (sound) { return sound.categoryId === category.id; });
                    if (catSounds.length > 0 &&
                        !confirm("Are you sure you want to delete this category? All ".concat(catSounds.length, " sound(s) will be deleted as well."))) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    categories.delete(category);
                    return [4 /*yield*/, api_1.api.deleteCategory(category)];
                case 1:
                    _a.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var renameCategory = function (category) { return __awaiter(_this, void 0, void 0, function () {
        var name;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    name = (_a = prompt('Enter category name:', category.name)) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!name)
                        return [2 /*return*/];
                    setIsLoading(true);
                    category.name = name;
                    categories.update(category);
                    return [4 /*yield*/, api_1.api.saveCategory(category)];
                case 1:
                    _b.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSortCategory = function (fromIndex, toIndex) { return __awaiter(_this, void 0, void 0, function () {
        var newCategories;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    newCategories = categories.moveIndex(fromIndex, toIndex);
                    return [4 /*yield*/, api_1.api.sortCategories(newCategories)];
                case 1:
                    _a.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var listCategorySounds = function (category) {
        return sounds.get().filter(function (sound) { return sound.categoryId === activeCategory.id; });
    };
    var addSound = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isLoading || isSoundListLoading)
                return [2 /*return*/];
            document.getElementById('sound-admin-file').click();
            return [2 /*return*/];
        });
    }); };
    var onFile = function () { return __awaiter(_this, void 0, void 0, function () {
        var fileElement, soundData, _a, _b, e_1, hash, sound;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!activeCategory || isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    fileElement = document.getElementById('sound-admin-file');
                    if (!fileElement.files) return [3 /*break*/, 8];
                    soundData = null;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    _b = (_a = sound_1.sound).convert;
                    return [4 /*yield*/, fileElement.files[0].arrayBuffer()];
                case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                case 3:
                    soundData = _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    (0, utils_1.error)("Unable to decode sound: ".concat(e_1));
                    setIsLoadingTimeout();
                    return [2 /*return*/];
                case 5: return [4 /*yield*/, api_1.api.uploadSound(soundData)];
                case 6:
                    hash = _c.sent();
                    return [4 /*yield*/, api_1.api.saveSound({
                            name: fileElement.files[0].name,
                            hash: hash,
                            categoryId: activeCategory.id,
                            sort: (sounds.length() + 1) * 1000,
                        })];
                case 7:
                    sound = _c.sent();
                    sounds.update(sound);
                    _c.label = 8;
                case 8:
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var renameSound = function (sound) { return __awaiter(_this, void 0, void 0, function () {
        var name;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    name = (_a = prompt('Enter sound name:', sound.name)) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!name)
                        return [2 /*return*/];
                    setIsLoading(true);
                    sound.name = name;
                    sounds.update(sound);
                    return [4 /*yield*/, api_1.api.saveSound(sound)];
                case 1:
                    _b.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteSound = function (sound) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    sounds.delete(sound);
                    return [4 /*yield*/, api_1.api.deleteSound(sound)];
                case 1:
                    _a.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadSound = function (sound) { return __awaiter(_this, void 0, void 0, function () {
        var data, blob, audioURL, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api_1.api.downloadSound(sound)];
                case 1:
                    data = _a.sent();
                    blob = new Blob([data], { type: "application/octet-stream" });
                    audioURL = window.URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = audioURL;
                    link.download = "".concat(sound.name, ".dat");
                    link.click();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSortSound = function (fromIndex, toIndex) { return __awaiter(_this, void 0, void 0, function () {
        var categorySounds, fromSound, toSound;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading || isSoundListLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    categorySounds = listCategorySounds(activeCategory);
                    fromSound = categorySounds[fromIndex];
                    toSound = categorySounds[toIndex];
                    return [4 /*yield*/, api_1.api.sortSounds(sounds
                            .move(fromSound, toSound)
                            .filter(function (sound) { return sound.categoryId === activeCategory.id; }))];
                case 1:
                    _a.sent();
                    setIsLoadingTimeout();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "sound-admin".concat(isLoading ? ' loading' : ''), children: [(0, jsx_runtime_1.jsx)("h1", { children: "Sound Admin" }), (0, jsx_runtime_1.jsxs)("div", { className: "options", children: [(0, jsx_runtime_1.jsx)(button_1.default, { label: "Add Category", disabled: isLoading, onClick: addCategory }), (0, jsx_runtime_1.jsx)(button_1.default, { label: "Add Sound", disabled: isLoading, onClick: addSound })] }), (0, jsx_runtime_1.jsx)("input", { id: "sound-admin-file", type: "file", onChange: onFile }), (0, jsx_runtime_1.jsxs)("div", { className: "categories", style: { height: "".concat(height - 150, "px") }, children: [(0, jsx_runtime_1.jsx)("div", { className: "section-title", children: "Categories" }), activeCategory && ((0, jsx_runtime_1.jsx)(react_easy_sort_1.default, { onSortEnd: onSortCategory, className: "category-sort", draggedItemClassName: "category-dragged", lockAxis: "y", children: categories.get().map(function (category) { return ((0, jsx_runtime_1.jsx)(react_easy_sort_1.SortableItem, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(sound_admin_option_1.default, { active: !isLoading &&
                                        activeCategory.id === category.id, label: category.name, onClick: function () {
                                        return setActiveCategory(category);
                                    }, onDelete: function () {
                                        return deleteCategory(category);
                                    }, onEdit: function () { return renameCategory(category); } }, "category-".concat(category.id)) }) }, "sort-category-".concat(category.id))); }) }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "sounds", style: { height: "".concat(height - 150, "px") }, children: [(0, jsx_runtime_1.jsx)("div", { className: "section-title", children: "Sounds" }), activeCategory && ((0, jsx_runtime_1.jsx)(react_easy_sort_1.default, { onSortEnd: onSortSound, className: "sound-sort", children: listCategorySounds(activeCategory).map(function (sound) { return ((0, jsx_runtime_1.jsx)(react_easy_sort_1.SortableItem, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(sound_admin_option_1.default, { label: sound.name, onEdit: function () { return renameSound(sound); }, onDelete: function () { return deleteSound(sound); }, onDownload: function () { return downloadSound(sound); } }, "sound-".concat(sound.id)) }) }, "sort-sound-".concat(sound.id))); }) }))] })] }));
}
exports.default = SoundAdmin;
